var React = require('react');

function StatusOnHold (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M0 0h23v23H0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"key":0},[React.createElement("mask",{"fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"d":"M11.5 0C5.16 0 0 5.157 0 11.5 0 17.84 5.16 23 11.5 23 17.841 23 23 17.84 23 11.5 23 5.157 17.841 0 11.5 0","fill":"#F93","mask":"url(#b)","key":1})]),React.createElement("path",{"d":"M16.325 10.613H6.674a.886.886 0 0 0-.885.885c0 .488.398.884.885.884h9.651a.885.885 0 0 0 0-1.769","fill":"#FFF","key":1})])]);
}

StatusOnHold.defaultProps = {"viewBox":"0 0 23 23"};

module.exports = StatusOnHold;

StatusOnHold.default = StatusOnHold;
